export default __webpack_public_path__ + "static/media/antp_CartaPorte_Redes-Whats.93af55f9.jpg";